import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { scrollTop } from '@/helpers/utils';
import { ACCOUNT_TYPES } from '@/helpers/constants';
import { Pagination } from '@/components/Pagination';
import { useGetPortfolioMovementsList } from '@/query/queries/activity/useGetPortfolioMovementsList';
import { TablePersonal } from './tablePersonal';
import { TableBusiness } from './tableBusiness';
import s from './index.module.scss';

export const DataView = ({ params, setParams }) => {
  const { type: accountType } = useOutletContext();
  const { data, isLoading } = useGetPortfolioMovementsList({
    page: params.page,
    date_from: params.range[0],
    date_to: params.range[1],
    operation_types: params.operation_types,
    grouping: JSON.stringify(params.grouping),
    type: accountType,
  });

  useEffect(() => {
    scrollTop();
  }, [params.page]);

  return (
    <div className={s.wrapper}>
      {accountType === ACCOUNT_TYPES.personal && (
        <TablePersonal isLoading={isLoading} data={data} grouping={params.grouping} />
      )}
      {accountType === ACCOUNT_TYPES.business && (
        <TableBusiness isLoading={isLoading} data={data} grouping={params.grouping} />
      )}
      {data?.total_pages > 0 && (
        <Pagination
          currentPage={params.page - 1}
          totalPages={data?.total_pages}
          onPageChange={({ selected }) => setParams(prev => ({ ...prev, page: selected + 1 }))}
        />
      )}
    </div>
  );
};
